class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    // Add mouseenter and mouseleave events
    this.mainDetailsToggle.addEventListener(
      "mouseenter",
      this.onMouseEnter.bind(this)
    );
    this.mainDetailsToggle.addEventListener(
      "mouseleave",
      this.onMouseLeave.bind(this)
    );
  }

  onMouseEnter() {
    this.open();
  }

  onMouseLeave() {
    this.close();
  }

  open() {
    this.mainDetailsToggle.setAttribute("open", true);
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", true);
    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.play());
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    if (this.animations) {
      this.animations.forEach((animation) => animation.cancel());
    }
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  open() {
    if (!this.header) return;
    this.header.preventHide = true;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) === ""
    ) {
      document.documentElement.style.setProperty(
        "--header-bottom-position-desktop",
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
    super.open();
  }

  close() {
    this.header.preventHide = false;
    super.close();
  }
}

customElements.define("header-menu", HeaderMenu);
